import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cpfInput", "nameInput", "phoneInput", "birthDateInput", "leadBadge"]
  static values = { lookupUrl: String }

  async lookup() {
    const cpf = this.cpfInputTarget.value.trim()
    if (!cpf) return

    try {
      const url = new URL(this.lookupUrlValue, window.location.origin)
      url.searchParams.set("cpf", cpf)
      const response = await fetch(url, {
        headers: { Accept: "application/json" }
      })
      const data = await response.json()

      if (data.found) {
        this.nameInputTarget.value = data.name || ""
        this.phoneInputTarget.value = this.#applyPhoneMask(data.phone || "")
        this.birthDateInputTarget.value = data.birth_date || ""
        this.#showBadge("Lead encontrado", "bg-green-100", "text-green-800")
      } else {
        this.nameInputTarget.value = ""
        this.phoneInputTarget.value = ""
        this.birthDateInputTarget.value = ""
        this.#showBadge("Novo lead", "bg-yellow-100", "text-yellow-800")
      }
    } catch (_) {
      // ignore network errors silently
    }
  }

  formatPhone() {
    const input = this.phoneInputTarget
    input.value = this.#applyPhoneMask(input.value)
  }

  #applyPhoneMask(value) {
    const digits = value.replace(/\D/g, "").slice(0, 11)
    if (digits.length <= 2) return digits
    if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`
    if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
  }

  #showBadge(text, bgClass, textClass) {
    const badge = this.leadBadgeTarget
    badge.textContent = text
    badge.className = `text-xs font-semibold px-2 py-1 rounded-full whitespace-nowrap ${bgClass} ${textClass}`
  }
}
